export var ELinkOpenMode = /*#__PURE__*/function (ELinkOpenMode) {
  ELinkOpenMode["Parent"] = "_parent";
  ELinkOpenMode["Blank"] = "_blank";
  ELinkOpenMode["Top"] = "_top";
  ELinkOpenMode["Self"] = "_self";
  return ELinkOpenMode;
}({});